import React from 'react';
import Physician from './physician';

export default function IndexPhysician() {
  return (
    <Physician /> 
  );
}